import axios from "axios";
const API = axios.create({baseURL:`${process.env.REACT_APP_BACKEND_URL}`,withCredentials: true});
API.defaults.headers.post["Content-Type"] = "application/json";
class CartService {
    static addToCart(item) {
        return API.post(`/api/cart/add-to-cart`,item);
    }
    static getCartItems() {
        return API.get(`/api/cart/get-cart-items`);
    }
    static clearCart() {
        return API.patch('/api/cart/clear-cart');
    }
    static createOrder(amount) {
        return API.post('/api/cart/create-order',{amount});
    }
    static verifyPayment(data) {
        return API.post('/api/cart/verify-payment',data);
    }
    static placeCashOnDelivery(data) {
        return API.post('/api/cart/place-cod-order',data);
    }
    static removeItem(itemId) {
        return API.put('/api/cart/remove-item',{ itemId })
    }
    static updateOrderAddress(orderId, newAddress) 
    {
        let url = '/api/cart/update-order-service';
        return API.put(url,{orderId,newAddress});
    }
}
export default CartService;